import { Avatar, Box, Button, CircularProgress, Divider, Grid2, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import html2pdf from "html2pdf.js";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import PaidIcon from "@mui/icons-material/Paid";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import BasicTenderInfo from "./BriefTender/BasicTenderInfo.jsx";
import CommentSection from "./BriefTender/CommentSection.jsx";
import VendorQualificationTab from "./BriefTender/VendorQualificationTab.jsx";
import QueriesTab from "./BriefTender/QueriesTab.jsx";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const BriefTender = () => {
  const [activeTab, setActiveTab] = useState(
    localStorage.getItem("tab") || ""
  );
  const [tender, setTender] = useState();
  const [workItems, setWorkItems] = useState();
  const { tenderId } = useParams();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [status, setStatus] = useState();
  const [reason, setReason] = useState("");
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [countVTQ, setCountVTQ] = useState(0);
  const [countQuery, setCountQuery] = useState(0);
  const [countEMD, setCountEMD] = useState(0);
  const [countBid, setCountBid] = useState(0);
  const [vtqLoading, setVtqLoading] = useState(true)
  const [emdLoading, setEmdLoading] = useState(true)
  const [bidLoading, setBidLoading] = useState(true)
  const [queryLoading, setQueryLoading] = useState(true)

  useEffect(() => {
    const getTender = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/tender/get-by-id?tenderId=${tenderId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setTender(res.data);
        setWorkItems(res.data.workItemDetails);
      } catch (error) {
        console.error("Error updating tender status:", error);
      }
    };
    getTender();
  }, []);

  useEffect(() => {
    const getVQCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vtq/count?tenderId=${tenderId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setCountVTQ(res.data);
        setVtqLoading(false)
      } catch (error) {
        console.error(error);
      }
    };
    getVQCount();
  }, [tender]);

  useEffect(() => {
    const getQueryCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/query/count?tenderId=${tenderId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setCountQuery(res.data);
        setQueryLoading(false)
      } catch (error) {
        console.error(error);
      }
    };
    getQueryCount();
  }, [tender]);

  useEffect(() => {
    const getBidCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/bid/count?tenderId=${tenderId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setCountBid(res.data);
        setBidLoading(false)
      } catch (error) {
        console.error(error);
      }
    };
    getBidCount();
  }, [tender]);

  useEffect(() => {
    const getEMDCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vendor-emd/count?tenderId=${tenderId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setCountEMD(res.data);
        setEmdLoading(false)
      } catch (error) {
        console.error(error);
      }
    };
    getEMDCount();
  }, [tender]);

  return (
    <div>
      {tender && (
        <div>
          {/* {(storedUser.userRole[0] !== "BUYER" ||
            storedUser.userRole[0] !== "FINANCE_HEAD") && (
              <div style={{ display: "flex", justifyContent: "end" }}>
                <Button className="btn-outlined" sx={{ width: "250px" }}>
                  Download All Bids Data
                </Button>
              </div>
            )} */}
          <Typography variant="h5">Basic Information</Typography>

          <BasicTenderInfo tender={tender} />

          <div
            className="dashboard-container"
            style={{ display: "flex", justifyContent: "space-around" }}
          >
            <div>
              <div className="tender-card" style={{ background: "#FFF5E0" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                  }}
                >
                  <div
                    style={{
                      borderRadius: "50%",
                      background: "#fff",
                      padding: "10px",
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    <PersonOutlineOutlinedIcon />
                  </div>
                </div>
                <Typography style={{ fontSize: "44px", fontWeight: "bold" }}>
                  {vtqLoading ? <CircularProgress /> : countVTQ}
                </Typography>
                <Typography mt={-1}>Vendor Qualification</Typography>
              </div>
              <Button
                className={
                  activeTab === "VQ" ? "btn-contained" : "btn-outlined"
                }
                fullWidth
                onClick={() => setActiveTab("VQ")}
                disabled={storedUser.userRole[0] !== "BUYER" &&
                  storedUser.userRole[0] !== "TECHNICAL_HEAD" &&
                  storedUser.userRole[0] !== "PURCHASE_HEAD"
                }
              >
                Vendor Qualification
              </Button>
            </div>

            <div>
              <div className="tender-card" style={{ background: "#E0F8EA" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                  }}
                >
                  <div
                    style={{
                      borderRadius: "50%",
                      background: "#fff",
                      padding: "10px",
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    <PaidIcon />
                  </div>
                </div>
                <Typography style={{ fontSize: "44px", fontWeight: "bold" }}>
                  {emdLoading ? <CircularProgress /> : countEMD}
                </Typography>
                <Typography mt={-1}>Total Vendor EMD</Typography>
              </div>
              <Button
                className={
                  activeTab === "EMD" ? "btn-contained" : "btn-outlined"
                }
                fullWidth
                onClick={() => {
                  localStorage.setItem("tab", "EMD")
                  setActiveTab("EMD")
                }}
                disabled={storedUser.userRole[0] !== "FINANCE_HEAD"}
              >
                Vendor EMD
              </Button>
            </div>

            <div>
              <div className="tender-card" style={{ background: "#EFE6F6" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                  }}
                >
                  <div
                    style={{
                      borderRadius: "50%",
                      background: "#fff",
                      padding: "10px",
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    <ShowChartIcon />
                  </div>
                </div>
                <Typography style={{ fontSize: "44px", fontWeight: "bold" }}>
                  {bidLoading ? <CircularProgress /> : countBid}
                </Typography>
                <Typography mt={-1}>Total Bid Received</Typography>
              </div>
              <Button
                className="btn-outlined"
                fullWidth
                disabled={storedUser.userRole[0] !== "TECHINCAL_HEAD" &&
                  storedUser.userRole[0] !== "PURCHASE_HEAD" &&
                  storedUser.userRole[0] !== "COO" &&
                  storedUser.userRole[0] !== "CFO" &&
                  storedUser.userRole[0] !== "CMD" &&
                  storedUser.userRole[0] !== "CEO"
                }
                onClick={() => {
                  localStorage.setItem("tab", "BIDS")
                  navigate("/dashboard")
                }}
              >
                Bid Received
              </Button>
            </div>

            <div>
              <div className="tender-card" style={{ background: "#FCEAE4" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                  }}
                >
                  <div
                    style={{
                      borderRadius: "50%",
                      background: "#fff",
                      padding: "10px",
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    <DescriptionOutlinedIcon />
                  </div>
                </div>
                <Typography style={{ fontSize: "44px", fontWeight: "bold" }}>
                  {queryLoading ? <CircularProgress /> : countQuery}
                </Typography>
                <Typography mt={-1}>Total Queries</Typography>
              </div>
              <Button
                className={
                  activeTab === "QUERY" ? "btn-contained" : "btn-outlined"
                }
                fullWidth
                onClick={() => setActiveTab("QUERY")}
                disabled={storedUser.userRole[0] !== "TECHNICAL_HEAD"}
              >
                Queries
              </Button>
            </div>
          </div>
          {activeTab === "VQ" ||
          ((activeTab === "EMD" || activeTab === "PURCHASE") && storedUser.userRole[0] === "FINANCE_HEAD") ? (
            <VendorQualificationTab />
          ) : (activeTab === "QUERY" && storedUser.userRole[0] === "TECHNICAL_HEAD") ? (
            <QueriesTab />
          ) : (
            <CommentSection tender={tender} storedUser={storedUser} />
          )}
        </div>
      )}
    </div>
  );
};

export default BriefTender;
